module.exports = "/img/11.1312cf.webp";